import { widgets } from '.';

export const manifest = Object.keys(widgets).map((widgetName) => {
  const details = widgets[widgetName].manifestInfo;

  return {
    type: widgetName,
    name: `${widgetName} Widget`,
    ...details,
    hidden: details.deprecated || details.hidden,
  };
});
